<!-- component -->

<div class="flex justify-center bg-hero bg-no-repeat bg-cover bg-center w-screen max-w-screen items-center py-10"
    style="background-image: url('https://images.unsplash.com/photo-1670387965791-5524e9d1259a?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1787&q=80');">
    <div class="sm:max-w-lg w-full h-fit p-6 bg-white rounded-xl z-10">
        <div class="text-center">
            <h2 class="mt-5 text-3xl font-bold text-gray-900">
                File Upload!
            </h2>
            <p class="mt-2 text-sm text-gray-400">Lorem ipsum is placeholder text.</p>
        </div>
        <form class="mt-8 space-y-3" action="#" method="POST">
            <div class="grid grid-cols-1 space-y-2">
                <label class="text-sm font-bold text-gray-500 tracking-wide">Title</label>
                <!-- <input
                    class="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500"
                    type="" placeholder="mail@gmail.com"> -->
                <select class="text-base p-2 border border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500" name="file-type" id="file-type">
                    <option value="cv">CV</option>
                    <option value="jd">JD</option>
                </select>
            </div>
            <div class="grid grid-cols-1 space-y-2">
                <label class="text-sm font-bold text-gray-500 tracking-wide">Attach Document</label>
                <div class="flex items-center justify-center w-full">
                    <label class="flex flex-col rounded-lg border-4 border-dashed w-full h-60 p-10 group text-center">
                        <div class="h-full w-full text-center flex flex-col items-center justify-center ">

                            <div class="flex flex-auto max-h-4 w-2/5 mx-auto -mt-10">
                            </div>
                            <p class="pointer-none text-gray-500 "><span class="text-sm">Drag and drop</span> files here
                                <br /> or <a href="" id="" class="text-blue-600 hover:underline">select a file</a> from
                                your computer
                            </p>
                        </div>
                        <input type="file" class="hidden">
                    </label>
                </div>
            </div>
            <p class="text-sm text-gray-300">
                <span>File type: doc,pdf,types of images</span>
            </p>
            <div>
                <button type="submit"
                    class="my-5 w-full flex justify-center bg-blue-500 text-gray-100 p-4  rounded-full tracking-wide
                                    font-semibold  focus:outline-none focus:shadow-outline hover:bg-blue-600 shadow-lg cursor-pointer transition ease-in duration-300">
                    Upload
                </button>
            </div>
        </form>
    </div>
</div>
